export const oem = () => {
  if (document.querySelector('.oem') && window.innerWidth > 999) {
    gsap.registerPlugin(ScrollTrigger);

    (function initOemAnimation() {
      const section   = document.querySelector('.oem');
      const images    = gsap.utils.toArray('.oem__image');
      const texts     = gsap.utils.toArray('.oem__text');
      const progress  = document.querySelector('.oem__progress > div');

      if (!section || !images.length) return;

      const TOTAL = images.length;

      gsap.set(images, { position: 'absolute', top: 0, left: 0, width: '100%' });

      images.forEach((img, i) => {
        gsap.set(img, { yPercent: i === 0 ? 0 : 100, opacity: i === 0 ? 1 : 0 });
      });

      const wrapper = document.querySelector('.oem__images');
      if (wrapper) {
        Object.assign(wrapper.style, {
          position: 'relative',
          overflow: 'hidden',
        });
        wrapper.style.paddingBottom = '';
        wrapper.style.height = wrapper.offsetWidth
          ? wrapper.offsetWidth * (360 / 647) + 'px'
          : '360px';
      }
      const textsWrapper = document.querySelector('.oem__texts');
      if (textsWrapper) {
        Object.assign(textsWrapper.style, { position: 'relative', overflow: 'hidden' });

        const firstTextH = texts[0] ? texts[0].offsetHeight : 200;
        textsWrapper.style.height = firstTextH + 'px';
      }

      gsap.set(texts, { position: 'absolute', top: 0, left: 0, width: '100%' });
      texts.forEach((t, i) => {
        gsap.set(t, { yPercent: i === 0 ? 0 : 100, opacity: i === 0 ? 1 : 0 });
      });
      if (progress) {
        gsap.set(progress, { width: '0%' });
      }
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'bottom bottom',
          end: () => `+=${window.innerHeight * (TOTAL - 1)}`,
          pin: true,
          scrub: 1,
          anticipatePin: 1,
          snap: {
            snapTo: 1 / (TOTAL - 1),
            duration: { min: 0.2, max: 0.5 },
            ease: "power1.inOut"
          },
          onEnter: () => document.querySelector('header').classList.add('header-anim'),
          onLeave: () => document.querySelector('header').classList.remove('header-anim'),
          onEnterBack: () => document.querySelector('header').classList.add('header-anim'),
          onLeaveBack: () => document.querySelector('header').classList.remove('header-anim'),
          onUpdate(self) {
            if (progress) {
              gsap.set(progress, { width: (self.progress * 100) + '%' });
            }
          },
        },
      });

      for (let i = 0; i < TOTAL - 1; i++) {
        tl
          .to(images[i],    { yPercent: -100, opacity: 0, duration: 1, ease: 'power2.inOut' }, i)
          .fromTo(images[i + 1],
            { yPercent: 100, opacity: 0 },
            { yPercent: 0,   opacity: 1, duration: 1, ease: 'power2.inOut' }, i)
          .to(texts[i],     { yPercent: -100, opacity: 0, duration: 1, ease: 'power2.inOut' }, i)
          .fromTo(texts[i + 1],
            { yPercent: 100, opacity: 0 },
            { yPercent: 0,   opacity: 1, duration: 1, ease: 'power2.inOut' }, i);
      }
      window.addEventListener('resize', () => {
        if (wrapper) {
          wrapper.style.height = wrapper.offsetWidth * (360 / 647) + 'px';
        }
        ScrollTrigger.refresh();
      });
    })();
  }
}